import React from 'react'
import LiveTooltip from 'live/components/ui/tooltip'
import { Asterisk, Icon } from '../GeneralTextInput/styles'

export interface LabelProps {
    title?: string
    tooltip?: string
    required?: boolean
    className?: string
}

export function Label({ title, tooltip, required, className }: LabelProps) {
    return (
        <div className={className || 'titleContainer'}>
            {title ? (
                <div className="throttle-title">
                    <label htmlFor="valueInput">{title}</label>
                    {tooltip && (
                        <LiveTooltip
                            className={className}
                            content={<label style={{ color: 'white' }}>{tooltip}</label>}
                            position={'top'}
                        >
                            <Icon className={'far fa-info-circle'} />
                        </LiveTooltip>
                    )}
                    {required && <Asterisk>*</Asterisk>}
                </div>
            ) : null}
        </div>
    )
}
